var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarbonSettingsAdjust(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2H11.95C11.7 0.85 10.7 0 9.5 0C8.3 0 7.3 0.85 7.05 2H0V3H7.05C7.3 4.15 8.3 5 9.5 5C10.7 5 11.7 4.15 11.95 3H14V2ZM9.5 4C8.65 4 8 3.35 8 2.5C8 1.65 8.65 1 9.5 1C10.35 1 11 1.65 11 2.5C11 3.35 10.35 4 9.5 4Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10H2.05C2.3 11.15 3.3 12 4.5 12C5.7 12 6.7 11.15 6.95 10H14V9H6.95C6.7 7.85 5.7 7 4.5 7C3.3 7 2.3 7.85 2.05 9H0V10ZM4.5 8C5.35 8 6 8.65 6 9.5C6 10.35 5.35 11 4.5 11C3.65 11 3 10.35 3 9.5C3 8.65 3.65 8 4.5 8Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonSettingsAdjust);
export default __webpack_public_path__ + "static/media/carbon_settings-adjust.49dd513cca7f52c4846c254c75913e08.svg";
export { ForwardRef as ReactComponent };